const CONSTANTS = {
  // Gift card form component
  // Delivery methods
  DIGITAL_DELIVERY: 'EMAIL',
  PHYSICAL_DELIVERY: 'MAIL',
  // form constants
  DEFAULT_AMOUNT_LABEL: 'Enter an amount',
  DEFAULT_AMOUNT_RANGE_LABEL: '(10$ - 1,000)*',
  INITIAL_MESSAGE_CHARACTER: 'Your message can be up to 120 characters.',
  TYPE_ERROR_SERVICE_ADD_CART: 'error',
  MSG_ERROR_SERVICE_ADD_CART: 'Something is wrong with the cart service response. Please try again later.',
  BTN_MSG_SHOW: 'Show more cards',
  BTN_MSG_FEWER: 'Show fewer cards',
  // special gift cards constants
  SPECIAL_AMOUNT_LABEL: 'Gift amount',
  HIPCAMP_VALUE: 100,
  HIPCAMP_RANGE_LABEL: '($50 REI + $50 Hipcamp)*',
  MEMBERSHIP_VALUE: 30,
  MEMBERSHIP_RANGE_VALUE: '($30 - $1000)*',
  MEMBERSHIP_MIN_VALUE: 30,
  MEMBERSHIP_MAX_VALUE: 1000,
  BRAILE_MSG: 'This card is for those with low or impaired vision and includes our company name, REI Co-op, in embossed Braille.',
  BRAILE_VALUE: 0,
  BRAILE_MIN_VALUE: 10,
  BRAILE_MAX_VALUE: 1000,
};

export default CONSTANTS;
